"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TriggerHistorySchemaProperties = exports.QuickBooksTriggerHistorySchema = exports.TriggerHistorySchema = void 0;
const zod_1 = require("zod");
const activity_log_schema_1 = require("./activity-log-schema");
const base_schema_1 = require("./base-schema");
const schema_properties_interface_1 = require("./schema-properties-interface");
const trigger_schema_1 = require("./trigger-schema");
// Base Trigger History
exports.TriggerHistorySchema = base_schema_1.BaseSchema.extend({
    id: zod_1.z.string(),
    trigger: trigger_schema_1.TriggerSchema,
    outcome: trigger_schema_1.TriggerOutcomeEnum,
    resourceId: zod_1.z.string(),
    resourceType: activity_log_schema_1.ResourceTypeEnum,
    actorId: zod_1.z.string(),
    actorType: activity_log_schema_1.ActorTypeEnum,
});
// QuickBooks Trigger History
exports.QuickBooksTriggerHistorySchema = exports.TriggerHistorySchema.extend({
    trigger: trigger_schema_1.QuickBooksTriggerSchema,
});
exports.TriggerHistorySchemaProperties = {
    collectionName: "triggerHistory",
    deleteMode: schema_properties_interface_1.DeleteMode.Soft,
};
//# sourceMappingURL=trigger-history-schema.js.map